import { Injectable } from '@angular/core';
import { TokenGateway } from '@domain/models/auth/gateway/token.gateway';
import { CypherService } from '../cypher-service/cypher.service';
import { IToken } from '@domain/interfaces/auth/auth-request.interface';
import { preserveFeatureFlagBypassStorage } from '@infraestructure/helpers/feature-flags/feature-flag-bypass.helper';
import { User } from '@domain/models/account-settings/user.model';

const token_key = 'auth-token';
const user_key = 'auth-user';

@Injectable({
  providedIn: 'root',
})
export class TokenService extends TokenGateway {
  constructor(private _cypherService: CypherService) {
    super();
  }

  clearStorage(): void {
    for (const key of Object.keys(localStorage)) {
      if (!key.startsWith("show-cross-sell-info")) {
        localStorage.removeItem(key);
      }
    }
    // keep the feature-flag bypass token: a logged-out visit wipes storage before login
    preserveFeatureFlagBypassStorage(() => sessionStorage.clear());
  }

  saveToken(token: IToken): void {
    localStorage.removeItem(token_key);
    localStorage.setItem(token_key, token?.accessToken!);
    // localStorage.setItem('refresh_token', data?.accessToken?.refreshToken);
  }

  getToken(): IToken | null {
    const tokenObj = localStorage.getItem(token_key)!;
    if (tokenObj) {
      return JSON.parse(tokenObj);
    } else {
      this.clearStorage();
    }
    return null;
  }

  saveUser(user: User): void {
    if (user) {
      localStorage.removeItem(user_key);
      localStorage.setItem(user_key, this._cypherService.encryptObject(JSON.stringify(user)) ?? '');
    }
  }

  getUser(): User | null {
    const userObj = this._cypherService.decryptObject(localStorage.getItem(user_key)!);
    if (userObj) {
      return JSON.parse(userObj);
    } else {
      this.clearStorage();
    }
    return null;
  }
}
